/* MUSLIMFY - Exit Intent Popup
 *
 * Detection :
 *   Desktop : mouseleave document avec clientY < 50 (souris monte vers URL bar / fermeture)
 *   Mobile  : pas de souris -> visibilitychange (switch onglet) + inactivity 60s fallback
 *
 * Garde-fous (best practices Privy / OptiMonk / OptinMonster) :
 *   - Delai minimum (configurable, defaut 10s) avant l'arme du listener
 *   - 1 affichage max par session (sessionStorage)
 *   - 1 affichage max par X jours (localStorage, configurable)
 *   - Skip si page est /cart, /checkout, /thank_you (intention forte deja exprimee)
 *   - Skip si user a deja un item dans le panier (analytics : intention forte = ne pas distraire)
 *
 * Comportement :
 *   - Click CTA : copie le code via navigator.clipboard, change label + couleur 2s
 *   - Close X / backdrop / Escape : ferme + flag localStorage + sessionStorage
 */
(function () {
  'use strict';

  var el = document.querySelector('[data-mfy-ep]');
  if (!el) return;

  var backdrop = document.querySelector('[data-mfy-ep-backdrop]');
  var btnClose = el.querySelector('[data-mfy-ep-close]');
  var btnCta = el.querySelector('[data-mfy-ep-cta]');
  var ctaLabel = el.querySelector('[data-mfy-ep-cta-label]');
  var codeDisplay = el.querySelector('[data-mfy-ep-code-display]');
  var form = el.querySelector('[data-mfy-ep-form]');
  var reveal = el.querySelector('[data-mfy-ep-reveal]');
  var emailInput = el.querySelector('#mfy-ep-email');
  var submitBtn = el.querySelector('[data-mfy-ep-submit]');
  var submitLabel = el.querySelector('[data-mfy-ep-submit-label]');
  var errorEl = el.querySelector('[data-mfy-ep-error]');
  var revealNote = el.querySelector('[data-mfy-ep-reveal-note]');
  var KL_COMPANY = el.getAttribute('data-klaviyo-company') || '';
  var KL_LIST = el.getAttribute('data-klaviyo-list') || '';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var KEY_SUBSCRIBED = 'mfy_exit_popup_subscribed';

  var DELAY_SEC = parseInt(el.getAttribute('data-delay-sec'), 10) || 10;
  var SHOW_AGAIN_DAYS = parseInt(el.getAttribute('data-show-again-days'), 10) || 7;
  var MOBILE_INACTIVITY_SEC = parseInt(el.getAttribute('data-mobile-inactivity-sec'), 10) || 30;
  var CODE = el.getAttribute('data-code') || '';
  var AFTER_COPY = el.getAttribute('data-after-copy') || 'Code copie !';
  var ORIGINAL_LABEL = ctaLabel ? ctaLabel.textContent : 'Copier le code';

  var KEY_SESSION = 'mfy_exit_popup_seen';
  var KEY_LOCAL = 'mfy_exit_popup_dismissed_at';
  var IS_MOBILE = window.matchMedia('(max-width: 768px)').matches || 'ontouchstart' in window;
  var INACTIVITY_MS = MOBILE_INACTIVITY_SEC * 1000;

  function skipPath() {
    var p = (window.location.pathname || '').toLowerCase();
    return p.indexOf('/cart') === 0
      || p.indexOf('/checkout') === 0
      || p.indexOf('/thank_you') === 0
      || p.indexOf('/orders/') === 0;
  }

  function alreadyShownSession() {
    try { return sessionStorage.getItem(KEY_SESSION) === '1'; } catch (e) { return false; }
  }

  function alreadyDismissedRecently() {
    try {
      var ts = parseInt(localStorage.getItem(KEY_LOCAL), 10);
      if (!ts) return false;
      var elapsedDays = (Date.now() - ts) / (1000 * 60 * 60 * 24);
      return elapsedDays < SHOW_AGAIN_DAYS;
    } catch (e) { return false; }
  }

  function markDismissed() {
    try { sessionStorage.setItem(KEY_SESSION, '1'); } catch (e) {}
    try { localStorage.setItem(KEY_LOCAL, String(Date.now())); } catch (e) {}
  }

  function shown() { return el.getAttribute('data-open') === 'true'; }

  function alreadySubscribed() {
    try { return localStorage.getItem(KEY_SUBSCRIBED) === '1'; } catch (e) { return false; }
  }

  // Inscription Klaviyo (API client publique) : la personne rejoint la liste Newsletter,
  // ce qui déclenche le flux de bienvenue (le code part aussi par e-mail).
  function klaviyoSubscribe(email, source) {
    if (!KL_COMPANY || !KL_LIST || !window.fetch) return Promise.resolve(false);
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KL_COMPANY), {
      method: 'POST',
      headers: { 'content-type': 'application/vnd.api+json', 'accept': 'application/vnd.api+json', 'revision': '2026-07-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: {
        email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
        relationships: { list: { data: { type: 'list', id: KL_LIST } } } } })
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }

  function show() {
    if (shown()) return;
    if (alreadyShownSession() || alreadyDismissedRecently() || alreadySubscribed() || skipPath()) return;
    el.setAttribute('data-open', 'true');
    if (backdrop) backdrop.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    try { sessionStorage.setItem(KEY_SESSION, '1'); } catch (e) {}
    // Focus le bouton close pour accessibilite (echap pour fermer)
    if (!IS_MOBILE && emailInput && form && !form.hidden) setTimeout(function () { emailInput.focus(); }, 60);
    else if (btnClose) setTimeout(function () { btnClose.focus(); }, 50);
  }

  function hide() {
    el.setAttribute('data-open', 'false');
    if (backdrop) backdrop.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
    markDismissed();
  }

  function copyCode() {
    function applySuccess() {
      if (!ctaLabel || !btnCta) return;
      btnCta.setAttribute('data-copied', 'true');
      ctaLabel.textContent = AFTER_COPY;
      setTimeout(function () {
        btnCta.setAttribute('data-copied', 'false');
        ctaLabel.textContent = ORIGINAL_LABEL;
      }, 2400);
    }
    function fallbackSelect() {
      try {
        var range = document.createRange();
        range.selectNodeContents(codeDisplay);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
        document.execCommand('copy');
        applySuccess();
      } catch (e) {}
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(CODE).then(applySuccess).catch(fallbackSelect);
    } else {
      fallbackSelect();
    }
  }

  // ─────────── Triggers ───────────
  var armed = false;
  function arm() {
    if (armed) return;
    armed = true;

    // 1. Desktop : mouseleave top
    document.addEventListener('mouseleave', function (e) {
      // clientY < 50 : souris monte vers URL bar / fermeture onglet
      // e.relatedTarget null sur leave fenetre, e.toElement aussi
      if (IS_MOBILE) return;
      if (e.clientY != null && e.clientY < 50) show();
    });

    // 2. Mobile : visibility change (changement d'onglet)
    var visTriggered = false;
    document.addEventListener('visibilitychange', function () {
      if (!IS_MOBILE) return;
      if (document.visibilityState === 'hidden' && !visTriggered) {
        visTriggered = true;
        // On show au retour de l'onglet (sinon popup invisible sur tab caché)
        var onVisible = function () {
          if (document.visibilityState === 'visible') {
            show();
            document.removeEventListener('visibilitychange', onVisible);
          }
        };
        document.addEventListener('visibilitychange', onVisible);
      }
    });

    // 3. Mobile fallback : inactivity 60s
    if (IS_MOBILE) {
      var inactivityTimer = null;
      var resetTimer = function () {
        if (inactivityTimer) clearTimeout(inactivityTimer);
        inactivityTimer = setTimeout(function () { show(); }, INACTIVITY_MS);
      };
      resetTimer();
      ['scroll', 'touchstart', 'click', 'keydown'].forEach(function (ev) {
        document.addEventListener(ev, resetTimer, { passive: true });
      });
    }
  }

  // Listeners de fermeture
  if (btnClose) btnClose.addEventListener('click', hide);
  if (backdrop) backdrop.addEventListener('click', hide);
  if (btnCta) btnCta.addEventListener('click', copyCode);
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = (emailInput && emailInput.value || '').trim();
    if (!EMAIL_RE.test(email)) {
      if (errorEl) errorEl.hidden = false;
      if (emailInput) { emailInput.setAttribute('aria-invalid', 'true'); emailInput.focus(); }
      return;
    }
    if (errorEl) errorEl.hidden = true;
    if (emailInput) emailInput.removeAttribute('aria-invalid');
    if (submitBtn) submitBtn.disabled = true;
    if (submitLabel) submitLabel.textContent = 'Un instant…';
    klaviyoSubscribe(email, 'Popup de sortie braizia.com').then(function (ok) {
      form.hidden = true;
      if (reveal) reveal.hidden = false;
      if (revealNote && ok) revealNote.textContent = "C'est noté : votre code arrive aussi par e-mail. Valable une fois, à coller au moment du paiement.";
      if (ok) { try { localStorage.setItem(KEY_SUBSCRIBED, '1'); } catch (err) {} }
      if (btnCta) btnCta.focus();
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && shown()) hide();
  });

  // Arme apres le delai min
  function bootstrap() {
    if (alreadyShownSession() || alreadyDismissedRecently() || alreadySubscribed() || skipPath()) return;
    setTimeout(arm, DELAY_SEC * 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();

/* Braizia : les formulaires newsletter du thème (pied de page, bandeaux) inscrivent aussi dans Klaviyo,
 * pour déclencher le flux de bienvenue. Le formulaire Shopify part ensuite normalement. */
(function () {
  'use strict';
  var COMPANY = 'WVx49G', LIST = 'XJq7sW';
  var RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM' || f.getAttribute('data-klaviyo-sent') === '1' || !window.fetch) return;
    var tag = f.querySelector('input[name="contact[tags]"]');
    var mail = f.querySelector('input[name="contact[email]"]');
    if (!tag || !mail || String(tag.value).indexOf('newsletter') === -1) return;
    var email = (mail.value || '').trim();
    if (!RE.test(email)) return;
    e.preventDefault();
    f.setAttribute('data-klaviyo-sent', '1');
    var done = false;
    var go = function () { if (done) return; done = true; HTMLFormElement.prototype.submit.call(f); };
    setTimeout(go, 2500);
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY, {
      method: 'POST',
      headers: { 'content-type': 'application/vnd.api+json', 'accept': 'application/vnd.api+json', 'revision': '2026-07-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Formulaire newsletter braizia.com', profile: { data: { type: 'profile', attributes: {
        email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
        relationships: { list: { data: { type: 'list', id: LIST } } } } })
    }).then(go, go);
  }, true);
})();
